import {useEffect, useMemo, useState} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {ItemSaleList} from '../../sales/components/ItemSaleList'
import {BillingList} from '../../sales/components/BillingList'
import {ContractList} from '../../sales/components/ContractList'
import {ResponsibleDetail} from '../../sales/components/ResponsibleDetail'
import {Outlet} from 'react-router-dom'
import {ContractListModal} from '../../sales/components/contracts-list-modal/ContractListModal'
import {useContractContext} from '../../sales/core/ContractProvider'
import {useBillingContext} from '../../sales/core/billingProvider'
import {ListSalesMedicalRecords} from '../../sales/components/ListSalesMedicalRecords'
import {ListSalesHistorySchedules} from '../../sales/components/ListSalesHistorySchedules'
import {getCalculateDistractById, getSaleMedicalRecordsById} from '../../sales/core/_request'
import {ContractListSalesStatus} from '../../sales/components/contractModal/ListSaleStatus'
import {SearchFranchise} from './FranchiseTransfer/SearchFranchise'
import {useFranchiseTransferCart} from './FranchiseTransfer/core/FranchiseTransferProvider'
import {FTMessageFinished} from './FranchiseTransfer/components/FTMessageFinished'
import {FTStatus} from './FranchiseTransfer/components/FTStatus'
import ReasonCancel from './CancelContract/ReasonCancel'
import {CalculateDistract} from '../../../coreGlobal/models/sale'
import {LoadingSpinner} from '../../../utils/loading/loadingSpinner'
import Swal from 'sweetalert2'
import {DistractList} from '../../../components/Distract/DistractList'
import {getReasons} from './FranchiseTransfer/core/_request'
import {ISelect} from '../../../coreGlobal/models/default'
import useAuthorization from '../../../hooks/useAuthorization'

import Select from 'react-select'
import {DropdownSale} from '../../sales/components/DropdownSale'

interface IPersonInfo {
  data: any
  close: any
  people: any
}

const ListSalesHistory = ({data}) => {
  const [dataSale, setDataSale] = useState()

  useEffect(() => {
    const init = async () => {
      try {
        const salesHistorySchedules = await getSaleMedicalRecordsById(Number(data))
        setDataSale(salesHistorySchedules)
      } catch (error: any) {
        if (error.response.status === 422) {
          let errorText = ''
          for (let key in error.response.data.errors) {
            errorText += '<li>' + error.response.data.errors[key][0] + '</li>'
          }
          await Swal.fire({
            icon: 'error',
            title: 'Ops! Revise seu formulário e tente novamente!',
            html: errorText,
            customClass: {
              confirmButton: 'btn btn-danger',
              cancelButton: 'btn btn-secondary',
            },
          })
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error.response.data.message,
            customClass: {
              confirmButton: 'btn btn-danger',
              cancelButton: 'btn btn-secondary',
            },
          })
        }
      }
    }
    init()
  }, [])

  return <ListSalesHistorySchedules salesHistorySchedules={dataSale} />
}

const SalesModal = ({data, close, people}: IPersonInfo) => {
  const {contractView} = useContractContext()
  const {setBillingData} = useBillingContext()
  const {transferStatus} = useFranchiseTransferCart()
  const [option, setOption] = useState<ISelect[]>([])

  const [calculateDistractItems, setCalculateDistractItems] = useState<CalculateDistract>()
  const [loading, setLoading] = useState(false)

  const STATUS_TO_HIDE_CANCELLATION = [4, 5, 7, 8, 11, 18]
  const STATUS_SHOW_TRANSFER = [8, 11, 15, 16, 18]

  const isAuthorizedToTransfersCreate = useAuthorization('transfers.create')
  const isAuthorizedToDistractsCreate = useAuthorization('distracts.create')
  const isAuthorizedToDistractsCancelProductContract = useAuthorization(
    'distracts.cancel_product_contract'
  )

  const isAuthorizedToDistractsViewIncorrectContract = useAuthorization(
    'distracts.view_incorrect_contract'
  )
  const isAuthorizedToDistractsViewCustomerWithdrawal = useAuthorization(
    'distracts.view_customer_withdrawal'
  )

  const cancellationTypeOption = useMemo(
    () => [
      {value: '1', label: 'Cancelar'},

      ...(isAuthorizedToDistractsViewIncorrectContract ||
      isAuthorizedToDistractsViewCustomerWithdrawal
        ? [{value: '2', label: 'Anular'}]
        : []),
    ],
    [isAuthorizedToDistractsViewIncorrectContract, isAuthorizedToDistractsViewCustomerWithdrawal]
  )

  const [cancellationType, setCancellationType] = useState<ISelect | null>(null)

  const onlyProductCategoryThree =
    data?.items?.length > 0 && data.items.every((item) => item.product?.category_id === 3)

  useEffect(() => {
    document.body.classList.add('modal-open')
    setBillingData(data.billings)
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  function closeModal() {
    close()
  }

  const getCalculateDistract = async (saleId: number) => {
    try {
      setLoading(true)
      const data = await getCalculateDistractById({id: saleId})
      setCalculateDistractItems(data)

      const reasonsData = await getReasons()

      const mappedOptions = reasonsData.map((item) => ({
        value: String(item.id),
        label: item.name,
        observation_required: item.observation_required,
      }))
      setOption(mappedOptions)
    } catch (error: any) {
      await Swal.fire({
        icon: 'error',
        title: 'Ops! Revise seu formulário e tente novamente!',
        html: error,
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary',
        },
      })
    } finally {
      setLoading(false)
    }
  }

  const filteredOptions = useMemo(() => {
    if (cancellationType === null) {
      return []
    }
    // Cancelar
    if (cancellationType?.value === '1') {
      return option.filter((item) => !['12', '13'].includes(item.value))
    }

    // Anular
    if (cancellationType?.value === '2') {
      return option.filter((item) => ['12', '13'].includes(item.value))
    }

    return option
  }, [option, cancellationType])

  const [status, setStatus] = useState('')

  useEffect(() => {
    if (data) {
      switch (data?.status) {
        case 'Pendente':
          setStatus('btn btn-light-primary')
          break
        case 'Pago':
          setStatus('btn btn-light-success')
          break
        case 'Cancelado':
          setStatus('btn btn-light-danger')
          break
        case 'Reprovada':
          setStatus('btn btn-light-danger')
          break
        case 'Em Análise':
          setStatus('btn btn-light-warning')
          break
        default:
          setStatus('btn btn-light-secondary')
      }
    }
  }, [data])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_edit_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-1000px'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2
                className='fw-bolder'
                style={{color: '#D31145'}}
              >{`Contrato: ${data.id} -  ${people?.name}`}</h2>
              <div className='d-flex '>
                <h1 className='me-1'>
                  <a className={`${status}`}>Status: {data?.status}</a>
                </h1>
                {data && (
                  <DropdownSale
                    saleData={data}
                    canCanSale={
                      data.billings.some((billing) => billing.status === 'Pendente') || false
                    }
                    canChangePayment={
                      data.billings.some((billing) => billing.status === 'Pendente') || false
                    }
                  />
                )}
              </div>
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                onClick={closeModal}
                style={{cursor: 'pointer'}}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
            </div>
            <div className='modal-body scroll-y'>
              <Outlet />
              <div className='card mb-5 mb-xl-10'>
                <div className='card-body pt-9 pb-0'>
                  <div className='d-flex overflow-auto h-70px'>
                    <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                      <li className='nav-item'>
                        <button
                          className='nav-link active'
                          id='pills-items-contract-tab'
                          data-bs-toggle='pill'
                          data-bs-target='#pills-items-contract'
                          type='button'
                          role='tab'
                          aria-controls='pills-items-contract'
                          aria-selected='true'
                        >
                          Items da Venda
                        </button>
                      </li>
                      <li className='nav-item'>
                        <button
                          className='nav-link'
                          id='pills-demands-tab'
                          data-bs-toggle='pill'
                          data-bs-target='#pills-demands'
                          type='button'
                          role='tab'
                          aria-controls='pills-demands'
                          aria-selected='true'
                        >
                          Histórico Cobrança
                        </button>
                      </li>
                      <li className='nav-item'>
                        <button
                          className='nav-link'
                          id='pills-tabcontract-mod-tab'
                          data-bs-toggle='pill'
                          data-bs-target='#pills-tabcontract-mod'
                          type='button'
                          role='tab'
                          aria-controls='pills-tabcontract-mod'
                          aria-selected='true'
                        >
                          Contratos
                        </button>
                      </li>
                      <li className='nav-item'>
                        <button
                          className='nav-link'
                          id='pills-medical-records-tab'
                          data-bs-toggle='pill'
                          data-bs-target='#pills-medical-records'
                          type='button'
                          role='tab'
                          aria-controls='pills-medical-records'
                          aria-selected='true'
                        >
                          Prontuário
                        </button>
                      </li>
                      <li className='nav-item'>
                        <button
                          className='nav-link'
                          id='pills-history-schedules-tab'
                          data-bs-toggle='pill'
                          data-bs-target='#pills-history-schedules'
                          type='button'
                          role='tab'
                          aria-controls='pills-history-schedules'
                          aria-selected='true'
                        >
                          Histórico de agendamento
                        </button>
                      </li>
                      {data?.responsible && (
                        <li className='nav-item'>
                          <button
                            className='nav-link'
                            id='pills-responsible-tab'
                            data-bs-toggle='pill'
                            data-bs-target='#pills-responsible'
                            type='button'
                            role='tab'
                            aria-controls='pills-responsible'
                            aria-selected='true'
                          >
                            Responsável
                          </button>
                        </li>
                      )}
                      <li className='nav-item'>
                        <button
                          className='nav-link'
                          id='pills-salesHistory-tab'
                          data-bs-toggle='pill'
                          data-bs-target='#pills-salesHistory'
                          type='button'
                          role='tab'
                          aria-controls='pills-salesHistory'
                          aria-selected='true'
                        >
                          Histórico de Status
                        </button>
                      </li>
                      {isAuthorizedToTransfersCreate &&
                        STATUS_SHOW_TRANSFER.includes(data.statusId) && (
                          <li className='nav-item'>
                            <button
                              className='nav-link'
                              id='pills-transfer-tab'
                              data-bs-toggle='pill'
                              data-bs-target='#pills-transfer'
                              type='button'
                              role='tab'
                              aria-controls='pills-transfer'
                              aria-selected='true'
                            >
                              Transferência
                            </button>
                          </li>
                        )}
                      {isAuthorizedToDistractsCreate &&
                        STATUS_TO_HIDE_CANCELLATION.includes(data.statusId) &&
                        !transferStatus &&
                        (!onlyProductCategoryThree ||
                          isAuthorizedToDistractsCancelProductContract) && (
                          <li className='nav-item'>
                            <button
                              className='nav-link'
                              id='pills-cancel-contract-tab'
                              data-bs-toggle='pill'
                              data-bs-target='#pills-cancel-contract'
                              type='button'
                              role='tab'
                              aria-controls='pills-cancel-contract'
                              aria-selected='true'
                              onClick={() => getCalculateDistract(data?.id)}
                            >
                              Cancelar Contrato
                            </button>
                          </li>
                        )}
                      {data?.distracts.length > 0 && (
                        <li className='nav-item'>
                          <button
                            className='nav-link'
                            id='pills-distract-tab'
                            data-bs-toggle='pill'
                            data-bs-target='#pills-distract'
                            type='button'
                            role='tab'
                            aria-controls='pills-distract'
                            aria-selected='true'
                          >
                            Distrato
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
              <div className='tab-content' id='pills-tabContent'>
                <div
                  className='tab-pane fade show active p-4 pt-0 pt-md-4'
                  id='pills-items-contract'
                  role='tabpanel'
                  aria-labelledby='pills-checklist-tab'
                >
                  <div className='card mb-5 mb-xl-10'>
                    <ItemSaleList itemSaleData={data?.items} saleId={data?.id ? data.id : 0} />
                  </div>
                </div>
                <div
                  className='tab-pane fade p-4 pt-0 pt-md-4'
                  id='pills-demands'
                  role='tabpanel'
                  aria-labelledby='pills-checklist-tab'
                >
                  <div className='card mb-5 mb-xl-10'>
                    <BillingList saleStatus={data?.status} />
                  </div>
                </div>
                <div
                  className='tab-pane fade p-4 pt-0 pt-md-4'
                  id='pills-tabcontract-mod'
                  role='tabpanel'
                  aria-labelledby='pills-checklist-tab'
                >
                  <div className='card mb-5 mb-xl-10'>
                    <ContractList saleId={data?.id} />
                  </div>
                </div>
                <div
                  className='tab-pane fade p-4 pt-0 pt-md-4'
                  id='pills-medical-records'
                  role='tabpanel'
                  aria-labelledby='pills-checklist-tab'
                >
                  <div className='card mb-5 mb-xl-10'>
                    <ListSalesMedicalRecords saleId={data?.id} />
                  </div>
                </div>
                <div
                  className='tab-pane fade p-4 pt-0 pt-md-4'
                  id='pills-history-schedules'
                  role='tabpanel'
                  aria-labelledby='pills-checklist-tab'
                >
                  <div className='card mb-5 mb-xl-10'>
                    <ListSalesHistory data={data?.id} />
                  </div>
                </div>
                {data?.responsible && (
                  <div
                    className='tab-pane fade p-4 pt-0 pt-md-4'
                    id='pills-responsible'
                    role='tabpanel'
                    aria-labelledby='pills-checklist-tab'
                  >
                    <div className='card mb-5 mb-xl-10'>
                      <ResponsibleDetail responsibleData={data?.responsible} />
                    </div>
                  </div>
                )}
                <div
                  className='tab-pane fade p-4 pt-0 pt-md-4'
                  id='pills-salesHistory'
                  role='tabpanel'
                  aria-labelledby='pills-salesHistory-tab'
                >
                  <div className='card mb-5 mb-xl-10'>
                    <div className='card-body py-3'>
                      <>
                        <ContractListSalesStatus history={data?.history} />
                      </>
                    </div>
                  </div>
                </div>

                <div
                  className='tab-pane fade p-4 pt-0 pt-md-4'
                  id='pills-transfer'
                  role='tabpanel'
                  aria-labelledby='pills-transfer-tab'
                >
                  <div className='card mb-5 mb-xl-10'>
                    <div className='card-body py-3'>
                      <>
                        {(data.status === 'Agendamento' || data.status === 'Distrato Parcial') &&
                          !transferStatus && (
                            <SearchFranchise
                              saleId={data?.id}
                              close={closeModal}
                              itens={data?.items}
                            />
                          )}

                        {data.status === 'Transferencia Pendente' && (
                          <FTMessageFinished transfer={data?.transfer} />
                        )}
                        {data.status === 'Transferencia Concluida' && (
                          <FTStatus transfer={data?.transfer} />
                        )}
                      </>
                    </div>
                  </div>
                </div>

                <div
                  className='tab-pane fade p-4 pt-0 pt-md-4'
                  id='pills-cancel-contract'
                  role='tabpanel'
                  aria-labelledby='pills-cancel-contract-tab'
                >
                  <div className='card mb-5 mb-xl-10'>
                    <div className='card-body py-3'>
                      <>
                        {loading && (
                          <LoadingSpinner
                            title='Carregando'
                            style={{
                              width: '2rem',
                              height: '2rem',
                              colorSpinner: '#f1416c',
                              colorText: '#f1416c',
                            }}
                          />
                        )}
                        {!loading &&
                          STATUS_TO_HIDE_CANCELLATION.includes(data.statusId) &&
                          !transferStatus && (
                            <div className='row mb-6'>
                              <div className='column col-lg-4'>
                                <label className='col-lg-12 col-form-label fw-bold fs-6'>
                                  <span>Tipo de cancelamento?</span>
                                </label>
                                <div className='col-lg-10 fv-row'>
                                  <Select
                                    id={`cancellationType`}
                                    className='react-select-styled react-select-solid '
                                    classNamePrefix='react-select'
                                    onChange={(option) => {
                                      setCancellationType(option!)
                                    }}
                                    options={cancellationTypeOption}
                                    value={cancellationType}
                                    placeholder='Selecione'
                                  />
                                </div>
                              </div>
                              {cancellationType && (
                                <ReasonCancel
                                  saleId={data?.id}
                                  items={calculateDistractItems!}
                                  option={filteredOptions}
                                  closeModal={closeModal}
                                  cancellationType={cancellationType}
                                />
                              )}
                            </div>
                          )}
                      </>
                    </div>
                  </div>
                </div>

                {data?.distracts && (
                  <div
                    className='tab-pane fade p-4 pt-0 pt-md-4'
                    id='pills-distract'
                    role='tabpanel'
                    aria-labelledby='pills-checklist-tab'
                  >
                    <div className='card mb-5 mb-xl-10'>
                      <DistractList data={data?.distracts} />
                    </div>
                  </div>
                )}
              </div>
              {contractView && <ContractListModal saleId={data?.id} />}
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {SalesModal}
